import type { InstagramCommentData } from '../services/instagram.ts';

export function parseInstagramComment(content: unknown): InstagramCommentData | null {
  try {
    const value = typeof content === 'string' ? JSON.parse(content) : content;
    const comment = value?.instagram_comment;
    return comment && Number.isSafeInteger(comment.id) && comment.id > 0
      && typeof comment.text === 'string' && typeof comment.status === 'string' ? comment : null;
  } catch { return null; }
}
